import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/currencyFormatter";

interface StepperProps {
  steps: string[];
  currentStep: number;
  className?: string;
}

export function Stepper({ steps, currentStep, className }: StepperProps) {
  return (
    <div className={cn("w-full", className)}>
      <ol className="flex items-center w-full">
        {steps.map((step, index) => {
          const isActive = currentStep === index;
          const isCompleted = currentStep > index;

          return (
            <li
              key={index}
              className={cn(
                "flex items-center",
                index !== steps.length - 1 ? "w-full" : ""
              )}
            >
              <div className="flex items-center">
                {isCompleted ? (
                  <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-full shrink-0">
                    <Check className="w-4 h-4 text-primary-foreground" />
                  </div>
                ) : (
                  <div
                    className={cn(
                      "flex items-center justify-center w-8 h-8 rounded-full shrink-0 border-2",
                      isActive
                        ? "border-primary text-primary"
                        : "border-muted-foreground text-muted-foreground"
                    )}
                  >
                    {index + 1}
                  </div>
                )}
                <span
                  className={cn(
                    "ml-2 text-sm font-medium",
                    isActive
                      ? "text-foreground"
                      : isCompleted
                      ? "text-primary"
                      : "text-muted-foreground"
                  )}
                >
                  {step}
                </span>
              </div>
              {index !== steps.length - 1 && (
                <div
                  className={cn(
                    "w-full flex-1 mx-4 h-0.5",
                    currentStep > index ? "bg-primary" : "bg-muted"
                  )}
                />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
